import {ChangeDetectionStrategy, Component, EffectRef, InputSignal, OutputEmitterRef, WritableSignal, effect, inject, input, output, signal, untracked} from '@angular/core';
import {DialogModule} from "@syncfusion/ej2-angular-popups";
import {FormUserGroupMailComponent} from "../../../shared/elements/form-user-group-mail/form-user-group-mail.component";
import {HeadlineComponent} from "../../../shared/elements/headline/headline.component";
import {TooltipComponent} from "../../../shared/elements/tooltip/tooltip.component";
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";
import {DialogService} from "../../../shared/services/dialog.service";
import {CustomerService} from "../../../shared/services/customer.service";
import {ChatStore} from '../chat-store/chat-store';
import {UserMinimalResource} from '../../../shared/types/generated/userMinimalResource';

@Component({
    selector: 'app-dialog-chat-create-user',
    imports: [
        DialogModule,
        FormUserGroupMailComponent,
        HeadlineComponent,
        TooltipComponent,
        TranslatePipe
    ],
    templateUrl: './dialog-chat-create-user.component.html',
    styleUrl: './dialog-chat-create-user.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogChatCreateUserComponent {
  public dialogService: DialogService = inject(DialogService);
  public customerService: CustomerService = inject(CustomerService);
  private chatStore: InstanceType<typeof ChatStore> = inject(ChatStore);

  public visible: InputSignal<boolean> = input<boolean>(false);
  public openCreatedChat: InputSignal<boolean> = input<boolean>(true);
  public visibleChange: OutputEmitterRef<boolean> = output<boolean>();
  public chatSaved: OutputEmitterRef<void> = output<void>();

  public participantsUserIDs: WritableSignal<number[]> = signal<number[]>([]);
  public participantsUserModels: WritableSignal<UserMinimalResource[]> = signal<UserMinimalResource[]>([]);

  private saveEffect: EffectRef = effect(() => {
    const userId = this.participantsUserModels()[0]?.id;
    if(userId) {
      untracked(() => {
        this.chatStore.startChatWithParticipant(userId, () => {
          this.chatSaved.emit();
          this.close();
        }, {navigateToChat: this.openCreatedChat()});
      })
    }
  });

  public close(): void {
    this.participantsUserIDs.set([]);
    this.participantsUserModels.set([]);
    this.visibleChange.emit(false);
  }
}
